import React, { FC } from 'react';
import { PaymentModalWrapper } from 'src/payments/components/PaymentsModals/PaypalModalWrapper';
import { StripeModalBase } from '.';
import { OnboardModalProps } from 'src/payments/types';
import { useIsPaymentsEnabled } from 'src/payments/hooks/useIsPaymentsEnabled';

export const StripeModal: FC<OnboardModalProps> = ({ origin, closeModal }) => {
  const isPaymentsEnabled = useIsPaymentsEnabled();
  if (!isPaymentsEnabled) return null;
  return (
    <PaymentModalWrapper isOpen={true} onRequestClose={closeModal}>
      <div id={'tailwind'}>
        <StripeModalBase closeModal={closeModal} origin={origin} />
      </div>
    </PaymentModalWrapper>
  );
};
